import { render, staticRenderFns } from "./payfor.vue?vue&type=template&id=147e65d6&"
import script from "./payfor.vue?vue&type=script&lang=js&"
export * from "./payfor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports